// This is generated file

const translationKeys = {
	EnvironmentCheck: {
		InitialSteps: {
			AboutName: 'EnvironmentCheck.InitialSteps.AboutName',
			AboutDescription: 'EnvironmentCheck.InitialSteps.AboutDescription',
			ConfirmSettingsName: 'EnvironmentCheck.InitialSteps.ConfirmSettingsName',
			ConfirmSettingsDescription: 'EnvironmentCheck.InitialSteps.ConfirmSettingsDescription',
			GatherSettingsName: 'EnvironmentCheck.InitialSteps.GatherSettingsName',
			GatherSettingsDescription: 'EnvironmentCheck.InitialSteps.GatherSettingsDescription',
			StatusReportName: 'EnvironmentCheck.InitialSteps.StatusReportName',
			StatusReportDescription: 'EnvironmentCheck.InitialSteps.StatusReportDescription'
		},
		ExportButton: {
			Loading: 'EnvironmentCheck.ExportButton.Loading',
			Ready: 'EnvironmentCheck.ExportButton.Ready',
			Error: 'EnvironmentCheck.ExportButton.Error',
			AriaLabel: 'EnvironmentCheck.ExportButton.AriaLabel',
			Failed: 'EnvironmentCheck.ExportButton.Failed',
			Export: 'EnvironmentCheck.ExportButton.Export'
		},
		Notifications: {
			StepChanged: 'EnvironmentCheck.Notifications.StepChanged',
			StepError: 'EnvironmentCheck.Notifications.StepError'
		},
		Labels: {
			MainArea: 'EnvironmentCheck.Labels.MainArea'
		},
		NavigationButton: {
			Back: 'EnvironmentCheck.NavigationButton.Back',
			Next: 'EnvironmentCheck.NavigationButton.Next'
		},
		Callout: {
			Issue: {
				InfoText: 'EnvironmentCheck.Callout.Issue.InfoText',
				LinkText: 'EnvironmentCheck.Callout.Issue.LinkText',
				CorrelationId: 'EnvironmentCheck.Callout.Issue.CorrelationId'
			}
		},
		RestartButton: {
			AriaLabel: 'EnvironmentCheck.RestartButton.AriaLabel',
			Text: 'EnvironmentCheck.RestartButton.Text'
		},
		CloseButton: {
			AriaLabel: 'EnvironmentCheck.CloseButton.AriaLabel',
			Text: 'EnvironmentCheck.CloseButton.Text'
		},
		CancelButton: {
			AriaLabel: 'EnvironmentCheck.CancelButton.AriaLabel',
			Text: 'EnvironmentCheck.CancelButton.Text'
		},
		Footer: {
			AriaLabel: 'EnvironmentCheck.Footer.AriaLabel'
		},
		WizardTitle: {
			Content: 'EnvironmentCheck.WizardTitle.Content'
		},
		Wizard: {
			NavLabel: 'EnvironmentCheck.Wizard.NavLabel',
			ExpandButtonLabel: 'EnvironmentCheck.Wizard.ExpandButtonLabel',
			CollapseButtonLabel: 'EnvironmentCheck.Wizard.CollapseButtonLabel'
		},
		Fallback: 'EnvironmentCheck.Fallback'
	},
	About: {
		Title: {
			Content: 'About.Title.Content'
		},
		Paragraph: {
			First: 'About.Paragraph.First',
			Second: 'About.Paragraph.Second',
			Third: 'About.Paragraph.Third'
		},
		Terms: {
			Label: 'About.Terms.Label',
			Acknowledgement: 'About.Terms.Acknowledgement'
		}
	},
	CheckResult: {
		Status: {
			Completed: 'CheckResult.Status.Completed',
			Configured: 'CheckResult.Status.Configured',
			Matching: 'CheckResult.Status.Matching',
			Saved: 'CheckResult.Status.Saved',
			Executed: 'CheckResult.Status.Executed',
			NotMatching: 'CheckResult.Status.NotMatching',
			NotRun: 'CheckResult.Status.NotRun',
			Failed: 'CheckResult.Status.Failed',
			Issue: 'CheckResult.Status.Issue'
		},
		StepContainer: {
			Title: 'CheckResult.StepContainer.Title',
			Paragraph: {
				LeadingText: 'CheckResult.StepContainer.Paragraph.LeadingText',
				OrText: 'CheckResult.StepContainer.Paragraph.OrText',
				TrailingText: 'CheckResult.StepContainer.Paragraph.TrailingText'
			},
			InstallerDocs: {
				LinkText: 'CheckResult.StepContainer.InstallerDocs.LinkText'
			},
			ContactSupport: {
				LinkText: 'CheckResult.StepContainer.ContactSupport.LinkText'
			}
		},
		Icons: {
			Success: {
				AriaLabel: 'CheckResult.Icons.Success.AriaLabel'
			},
			Error: {
				AriaLabel: 'CheckResult.Icons.Error.AriaLabel'
			},
			Warning: {
				AriaLabel: 'CheckResult.Icons.Warning.AriaLabel'
			},
			Cube: {
				AriaLabel: 'CheckResult.Icons.Cube.AriaLabel'
			}
		},
		Columns: {
			Status: {
				AriaLabel: 'CheckResult.Columns.Status.AriaLabel',
				Name: 'CheckResult.Columns.Status.Name'
			},
			Title: {
				Name: 'CheckResult.Columns.Title.Name'
			},
			Details: {
				Name: 'CheckResult.Columns.Details.Name'
			}
		}
	},
	EnvChecker: {
		Configuration: {
			Step: {
				Title: 'EnvChecker.Configuration.Step.Title',
				Paragraph: {
					First: 'EnvChecker.Configuration.Step.Paragraph.First',
					Second: 'EnvChecker.Configuration.Step.Paragraph.Second'
				}
			}
		}
	},
	GatherInformation: {
		Step: {
			Default: {
				Title: 'GatherInformation.Step.Default.Title',
				Paragraph: 'GatherInformation.Step.Default.Paragraph',
				WarningMessage: 'GatherInformation.Step.Default.WarningMessage'
			},
			Fail: {
				Title: 'GatherInformation.Step.Fail.Title',
				Detail: 'GatherInformation.Step.Fail.Detail'
			}
		},
		Default: {
			ProgressIndicator: {
				Label: 'GatherInformation.Default.ProgressIndicator.Label'
			}
		}
	},
	DetailBox: {
		AriaLabel: 'DetailBox.AriaLabel',
		Status: 'DetailBox.Status',
		Title: 'DetailBox.Title',
		Type: 'DetailBox.Type',
		Detail: 'DetailBox.Detail',
		CorrelationId: 'DetailBox.CorrelationId',
		LinkText: 'DetailBox.LinkText'
	},
	Fail: {
		Img: {
			AltText: 'Fail.Img.AltText'
		}
	},
	PageNotFound: {
		PageName: 'PageNotFound.PageName',
		Img: {
			AltText: 'PageNotFound.Img.AltText'
		},
		Paragraph: {
			First: 'PageNotFound.Paragraph.First'
		},
		Button: {
			Text: 'PageNotFound.Button.Text'
		}
	},
	WarningMessage: {
		Paragraph: {
			AriaLabel: 'WarningMessage.Paragraph.AriaLabel'
		}
	},
	Layout: {
		MenuProps: {
			Item: {
				One: {
					AriaLabel: 'Layout.MenuProps.Item.One.AriaLabel',
					Text: 'Layout.MenuProps.Item.One.Text'
				},
				Two: {
					AriaLabel: 'Layout.MenuProps.Item.Two.AriaLabel',
					Text: 'Layout.MenuProps.Item.Two.Text'
				}
			}
		},
		NavigationMenuProps: {
			Item: {
				One: {
					AriaLabel: 'Layout.NavigationMenuProps.Item.One.AriaLabel',
					Text: 'Layout.NavigationMenuProps.Item.One.Text'
				},
				Two: {
					AriaLabel: 'Layout.NavigationMenuProps.Item.Two.AriaLabel',
					Text: 'Layout.NavigationMenuProps.Item.Two.Text'
				},
				Three: {
					AriaLabel: 'Layout.NavigationMenuProps.Item.Three.AriaLabel',
					Text: 'Layout.NavigationMenuProps.Item.Three.Text'
				},
				Four: {
					AriaLabel: 'Layout.NavigationMenuProps.Item.Four.AriaLabel',
					Text: 'Layout.NavigationMenuProps.Item.Four.Text'
				}
			}
		},
		Component: {
			Title: 'Layout.Component.Title',
			Nav: {
				AriaLabel: 'Layout.Component.Nav.AriaLabel'
			},
			SettingsButton: {
				AriaLabel: 'Layout.Component.SettingsButton.AriaLabel'
			},
			ProfileButton: {
				AriaLabel: 'Layout.Component.ProfileButton.AriaLabel'
			}
		},
		LanguageSelector: {
			Title: 'Layout.LanguageSelector.Title',
			Icon: {
				Alt: 'Layout.LanguageSelector.Icon.Alt'
			},
			Button: 'Layout.LanguageSelector.Button'
		}
	},
	AzureConfiguration: {
		Step: {
			Default: {
				Title: 'AzureConfiguration.Step.Default.Title',
				Paragraph: 'AzureConfiguration.Step.Default.Paragraph',
				WarningMessage: 'AzureConfiguration.Step.Default.WarningMessage'
			},
			Fail: {
				Title: 'AzureConfiguration.Step.Fail.Title',
				Detail: 'AzureConfiguration.Step.Fail.Detail'
			}
		},
		Default: {
			ProgressIndicator: {
				Label: 'AzureConfiguration.Default.ProgressIndicator.Label'
			}
		}
	},
	Deployment: {
		Configuration: {
			Step: {
				Title: 'Deployment.Configuration.Step.Title',
				Paragraph: 'Deployment.Configuration.Step.Paragraph',
				LinkText: 'Deployment.Configuration.Step.LinkText'
			}
		},
		InitialSteps: {
			One: {
				Name: 'Deployment.InitialSteps.One.Name',
				AriaDescription: 'Deployment.InitialSteps.One.AriaDescription'
			},
			Two: {
				Name: 'Deployment.InitialSteps.Two.Name',
				AriaDescription: 'Deployment.InitialSteps.Two.AriaDescription'
			},
			Three: {
				Name: 'Deployment.InitialSteps.Three.Name',
				AriaDescription: 'Deployment.InitialSteps.Three.AriaDescription'
			}
		},
		Notifications: {
			StepChanged: 'Deployment.Notifications.StepChanged',
			StepError: 'Deployment.Notifications.StepError'
		},
		Labels: {
			MainArea: 'Deployment.Labels.MainArea'
		},
		WizardTitle: {
			Content: 'Deployment.WizardTitle.Content'
		},
		Wizard: {
			NavLabel: 'Deployment.Wizard.NavLabel',
			ExpandButtonLabel: 'Deployment.Wizard.ExpandButtonLabel',
			CollapseButtonLabel: 'Deployment.Wizard.CollapseButtonLabel',
			Footer: {
				Back: 'Deployment.Wizard.Footer.Back',
				Continue: 'Deployment.Wizard.Footer.Continue',
				Content: {
					AriaLabel: 'Deployment.Wizard.Footer.Content.AriaLabel'
				}
			}
		},
		Fallback: 'Deployment.Fallback'
	},
	Success: {
		Step: {
			Title: 'Success.Step.Title',
			Paragraph: {
				First: {
					Text: 'Success.Step.Paragraph.First.Text',
					LinkText: 'Success.Step.Paragraph.First.LinkText'
				},
				Second: {
					Text: 'Success.Step.Paragraph.Second.Text'
				}
			},
			OpenWindowButton: {
				Text: 'Success.Step.OpenWindowButton.Text'
			},
			Img: {
				Alt: 'Success.Step.Img.Alt'
			}
		}
	},
	CustomLabel: {
		Title: {
			Suffix: {
				Info: 'CustomLabel.Title.Suffix.Info'
			}
		},
		AriaLabel: {
			Suffix: {
				Info: 'CustomLabel.AriaLabel.Suffix.Info'
			}
		}
	},
	Steps: {
		Configuration: {
			Organization: {
				ComboBox: {
					Label: 'Steps.Configuration.Organization.ComboBox.Label',
					Placeholder: 'Steps.Configuration.Organization.ComboBox.Placeholder',
					ErrorMessage: 'Steps.Configuration.Organization.ComboBox.ErrorMessage',
					Description: 'Steps.Configuration.Organization.ComboBox.Description',
					IconTitle: 'Steps.Configuration.Organization.ComboBox.IconTitle',
					IconAriaLabel: 'Steps.Configuration.Organization.ComboBox.IconAriaLabel'
				}
			},
			Subscription: {
				ComboBox: {
					Label: 'Steps.Configuration.Subscription.ComboBox.Label',
					Placeholder: 'Steps.Configuration.Subscription.ComboBox.Placeholder',
					ErrorMessage: 'Steps.Configuration.Subscription.ComboBox.ErrorMessage',
					Description: 'Steps.Configuration.Subscription.ComboBox.Description',
					IconTitle: 'Steps.Configuration.Subscription.ComboBox.IconTitle',
					IconAriaLabel: 'Steps.Configuration.Subscription.ComboBox.IconAriaLabel'
				}
			},
			ResourceGroup: {
				ComboBox: {
					Label: 'Steps.Configuration.ResourceGroup.ComboBox.Label',
					Placeholder: 'Steps.Configuration.ResourceGroup.ComboBox.Placeholder',
					ErrorMessage: 'Steps.Configuration.ResourceGroup.ComboBox.ErrorMessage',
					Description: 'Steps.Configuration.ResourceGroup.ComboBox.Description',
					IconTitle: 'Steps.Configuration.ResourceGroup.ComboBox.IconTitle',
					IconAriaLabel: 'Steps.Configuration.ResourceGroup.ComboBox.IconAriaLabel'
				}
			},
			Terms: {
				Title: 'Steps.Configuration.Terms.Title',
				Acknowledgement: 'Steps.Configuration.Terms.Acknowledgement'
			},
			Error: {
				MessageBar: {
					Actions: {
						Button: {
							Content: 'Steps.Configuration.Error.MessageBar.Actions.Button.Content'
						}
					},
					DismissAriaLabel: 'Steps.Configuration.Error.MessageBar.DismissAriaLabel',
					Content: {
						LeadingText: 'Steps.Configuration.Error.MessageBar.Content.LeadingText',
						ErrorId: 'Steps.Configuration.Error.MessageBar.Content.ErrorId'
					}
				}
			}
		}
	},
	Api: {
		UseResultFile: {
			CallApi: {
				Error: {
					Detail: 'Api.UseResultFile.CallApi.Error.Detail',
					Title: 'Api.UseResultFile.CallApi.Error.Title'
				}
			}
		}
	},
	AuthService: {
		ParseChallenge: {
			Error: 'AuthService.ParseChallenge.Error'
		}
	},
	App: {
		Fail: {
			Title: 'App.Fail.Title',
			Detail: 'App.Fail.Detail'
		}
	},
	DeprecationModal: {
		Banner: {
			Text: 'DeprecationModal.Banner.Text',
			Date: 'DeprecationModal.Banner.Date'
		},
		Title: 'DeprecationModal.Title',
		Intro: 'DeprecationModal.Intro',
		NextSteps: {
			Title: 'DeprecationModal.NextSteps.Title',
			Paragraph: 'DeprecationModal.NextSteps.Paragraph',
			PartnerText: 'DeprecationModal.NextSteps.PartnerText',
			PartnerLinkText: 'DeprecationModal.NextSteps.PartnerLinkText'
		},
		AcknowledgeButton: {
			Text: 'DeprecationModal.AcknowledgeButton.Text'
		},
		CloseButton: {
			AriaLabel: 'DeprecationModal.CloseButton.AriaLabel'
		}
	},
	EnvironmentCheckTitles: {
		SolutionVersion: 'EnvironmentCheckTitles.SolutionVersion',
		AzureVersion: 'EnvironmentCheckTitles.AzureVersion',
		InstallerSteps: 'EnvironmentCheckTitles.InstallerSteps',
		WebhookCheck: 'EnvironmentCheckTitles.WebhookCheck',
		ConfigurationRecord: 'EnvironmentCheckTitles.ConfigurationRecord',
		ManagedIdentity: 'EnvironmentCheckTitles.ManagedIdentity',
		ArmTemplateVersion: 'EnvironmentCheckTitles.ArmTemplateVersion',
		ArmTemplateDeployment: 'EnvironmentCheckTitles.ArmTemplateDeployment',
		SqlMigrations: 'EnvironmentCheckTitles.SqlMigrations',
		PaymentProcessor: 'EnvironmentCheckTitles.PaymentProcessor',
		KeyVaultCheck: 'EnvironmentCheckTitles.KeyVaultCheck'
	},
	EnvironmentCheckResponse: {
		SolutionVersion: {
			Title: 'EnvironmentCheckResponse.SolutionVersion.Title',
			Success: 'EnvironmentCheckResponse.SolutionVersion.Success'
		},
		AzureVersion: {
			Title: 'EnvironmentCheckResponse.AzureVersion.Title',
			Success: 'EnvironmentCheckResponse.AzureVersion.Success'
		},
		InstallerSteps: {
			Title: 'EnvironmentCheckResponse.InstallerSteps.Title',
			Success: 'EnvironmentCheckResponse.InstallerSteps.Success'
		},
		WebhookCheck: {
			Title: 'EnvironmentCheckResponse.WebhookCheck.Title',
			Success: 'EnvironmentCheckResponse.WebhookCheck.Success'
		},
		ConfigurationRecord: {
			Title: 'EnvironmentCheckResponse.ConfigurationRecord.Title',
			Success: 'EnvironmentCheckResponse.ConfigurationRecord.Success'
		},
		ManagedIdentity: {
			Title: 'EnvironmentCheckResponse.ManagedIdentity.Title',
			Success: 'EnvironmentCheckResponse.ManagedIdentity.Success'
		},
		ArmTemplateVersion: {
			Title: 'EnvironmentCheckResponse.ArmTemplateVersion.Title',
			Success: 'EnvironmentCheckResponse.ArmTemplateVersion.Success'
		},
		ArmTemplateDeployment: {
			Title: 'EnvironmentCheckResponse.ArmTemplateDeployment.Title',
			Success: 'EnvironmentCheckResponse.ArmTemplateDeployment.Success'
		},
		SqlMigrations: {
			Title: 'EnvironmentCheckResponse.SqlMigrations.Title',
			Success: 'EnvironmentCheckResponse.SqlMigrations.Success'
		},
		PaymentProcessor: {
			Title: 'EnvironmentCheckResponse.PaymentProcessor.Title',
			Success: 'EnvironmentCheckResponse.PaymentProcessor.Success'
		},
		KeyVaultCheck: {
			Title: 'EnvironmentCheckResponse.KeyVaultCheck.Title',
			Success: 'EnvironmentCheckResponse.KeyVaultCheck.Success'
		}
	},
	Errors: {
		1: {
			errorName: 'Errors.1.errorName',
			errorTitle: 'Errors.1.errorTitle',
			errorDescription: 'Errors.1.errorDescription'
		},
		2: {
			errorName: 'Errors.2.errorName',
			errorTitle: 'Errors.2.errorTitle',
			errorDescription: 'Errors.2.errorDescription'
		},
		3: {
			errorName: 'Errors.3.errorName',
			errorTitle: 'Errors.3.errorTitle',
			errorDescription: 'Errors.3.errorDescription'
		},
		4: {
			errorName: 'Errors.4.errorName',
			errorTitle: 'Errors.4.errorTitle',
			errorDescription: 'Errors.4.errorDescription'
		},
		5: {
			errorName: 'Errors.5.errorName',
			errorTitle: 'Errors.5.errorTitle',
			errorDescription: 'Errors.5.errorDescription'
		},
		6: {
			errorName: 'Errors.6.errorName',
			errorTitle: 'Errors.6.errorTitle',
			errorDescription: 'Errors.6.errorDescription'
		},
		7: {
			errorName: 'Errors.7.errorName',
			errorTitle: 'Errors.7.errorTitle',
			errorDescription: 'Errors.7.errorDescription'
		},
		8: {
			errorName: 'Errors.8.errorName',
			errorTitle: 'Errors.8.errorTitle',
			errorDescription: 'Errors.8.errorDescription'
		},
		9: {
			errorName: 'Errors.9.errorName',
			errorTitle: 'Errors.9.errorTitle',
			errorDescription: 'Errors.9.errorDescription'
		},
		10: {
			errorName: 'Errors.10.errorName',
			errorTitle: 'Errors.10.errorTitle',
			errorDescription: 'Errors.10.errorDescription'
		},
		11: {
			errorName: 'Errors.11.errorName',
			errorTitle: 'Errors.11.errorTitle',
			errorDescription: 'Errors.11.errorDescription'
		},
		4096: {
			errorName: 'Errors.4096.errorName',
			errorTitle: 'Errors.4096.errorTitle',
			errorDescription: 'Errors.4096.errorDescription'
		},
		4097: {
			errorName: 'Errors.4097.errorName',
			errorTitle: 'Errors.4097.errorTitle',
			errorDescription: 'Errors.4097.errorDescription'
		},
		4098: {
			errorName: 'Errors.4098.errorName',
			errorTitle: 'Errors.4098.errorTitle',
			errorDescription: 'Errors.4098.errorDescription'
		},
		4099: {
			errorName: 'Errors.4099.errorName',
			errorTitle: 'Errors.4099.errorTitle',
			errorDescription: 'Errors.4099.errorDescription'
		},
		4100: {
			errorName: 'Errors.4100.errorName',
			errorTitle: 'Errors.4100.errorTitle',
			errorDescription: 'Errors.4100.errorDescription'
		},
		4101: {
			errorName: 'Errors.4101.errorName',
			errorTitle: 'Errors.4101.errorTitle',
			errorDescription: 'Errors.4101.errorDescription'
		},
		4102: {
			errorName: 'Errors.4102.errorName',
			errorTitle: 'Errors.4102.errorTitle',
			errorDescription: 'Errors.4102.errorDescription'
		},
		4103: {
			errorName: 'Errors.4103.errorName',
			errorTitle: 'Errors.4103.errorTitle',
			errorDescription: 'Errors.4103.errorDescription'
		},
		4104: {
			errorName: 'Errors.4104.errorName',
			errorTitle: 'Errors.4104.errorTitle',
			errorDescription: 'Errors.4104.errorDescription'
		},
		4105: {
			errorName: 'Errors.4105.errorName',
			errorTitle: 'Errors.4105.errorTitle',
			errorDescription: 'Errors.4105.errorDescription'
		},
		4106: {
			errorName: 'Errors.4106.errorName',
			errorTitle: 'Errors.4106.errorTitle',
			errorDescription: 'Errors.4106.errorDescription'
		},
		8192: {
			errorName: 'Errors.8192.errorName',
			errorTitle: 'Errors.8192.errorTitle',
			errorDescription: 'Errors.8192.errorDescription'
		},
		8193: {
			errorName: 'Errors.8193.errorName',
			errorTitle: 'Errors.8193.errorTitle',
			errorDescription: 'Errors.8193.errorDescription'
		},
		8194: {
			errorName: 'Errors.8194.errorName',
			errorTitle: 'Errors.8194.errorTitle',
			errorDescription: 'Errors.8194.errorDescription'
		},
		8195: {
			errorName: 'Errors.8195.errorName',
			errorTitle: 'Errors.8195.errorTitle',
			errorDescription: 'Errors.8195.errorDescription'
		},
		8196: {
			errorName: 'Errors.8196.errorName',
			errorTitle: 'Errors.8196.errorTitle',
			errorDescription: 'Errors.8196.errorDescription'
		},
		8197: {
			errorName: 'Errors.8197.errorName',
			errorTitle: 'Errors.8197.errorTitle',
			errorDescription: 'Errors.8197.errorDescription'
		},
		8198: {
			errorName: 'Errors.8198.errorName',
			errorTitle: 'Errors.8198.errorTitle',
			errorDescription: 'Errors.8198.errorDescription'
		},
		8199: {
			errorName: 'Errors.8199.errorName',
			errorTitle: 'Errors.8199.errorTitle',
			errorDescription: 'Errors.8199.errorDescription'
		},
		8200: {
			errorName: 'Errors.8200.errorName',
			errorTitle: 'Errors.8200.errorTitle',
			errorDescription: 'Errors.8200.errorDescription'
		},
		8201: {
			errorName: 'Errors.8201.errorName',
			errorTitle: 'Errors.8201.errorTitle',
			errorDescription: 'Errors.8201.errorDescription'
		},
		8202: {
			errorName: 'Errors.8202.errorName',
			errorTitle: 'Errors.8202.errorTitle',
			errorDescription: 'Errors.8202.errorDescription'
		},
		8203: {
			errorName: 'Errors.8203.errorName',
			errorTitle: 'Errors.8203.errorTitle',
			errorDescription: 'Errors.8203.errorDescription'
		},
		8204: {
			errorName: 'Errors.8204.errorName',
			errorTitle: 'Errors.8204.errorTitle',
			errorDescription: 'Errors.8204.errorDescription'
		},
		8205: {
			errorName: 'Errors.8205.errorName',
			errorTitle: 'Errors.8205.errorTitle',
			errorDescription: 'Errors.8205.errorDescription'
		},
		8206: {
			errorName: 'Errors.8206.errorName',
			errorTitle: 'Errors.8206.errorTitle',
			errorDescription: 'Errors.8206.errorDescription'
		},
		8207: {
			errorName: 'Errors.8207.errorName',
			errorTitle: 'Errors.8207.errorTitle',
			errorDescription: 'Errors.8207.errorDescription'
		},
		8208: {
			errorName: 'Errors.8208.errorName',
			errorTitle: 'Errors.8208.errorTitle',
			errorDescription: 'Errors.8208.errorDescription'
		},
		8209: {
			errorName: 'Errors.8209.errorName',
			errorTitle: 'Errors.8209.errorTitle',
			errorDescription: 'Errors.8209.errorDescription'
		},
		8210: {
			errorName: 'Errors.8210.errorName',
			errorTitle: 'Errors.8210.errorTitle',
			errorDescription: 'Errors.8210.errorDescription'
		},
		8211: {
			errorName: 'Errors.8211.errorName',
			errorTitle: 'Errors.8211.errorTitle',
			errorDescription: 'Errors.8211.errorDescription'
		},
		8212: {
			errorName: 'Errors.8212.errorName',
			errorTitle: 'Errors.8212.errorTitle',
			errorDescription: 'Errors.8212.errorDescription'
		},
		8213: {
			errorName: 'Errors.8213.errorName',
			errorTitle: 'Errors.8213.errorTitle',
			errorDescription: 'Errors.8213.errorDescription'
		},
		8214: {
			errorName: 'Errors.8214.errorName',
			errorTitle: 'Errors.8214.errorTitle',
			errorDescription: 'Errors.8214.errorDescription'
		},
		8215: {
			errorName: 'Errors.8215.errorName',
			errorTitle: 'Errors.8215.errorTitle',
			errorDescription: 'Errors.8215.errorDescription'
		},
		8216: {
			errorName: 'Errors.8216.errorName',
			errorTitle: 'Errors.8216.errorTitle',
			errorDescription: 'Errors.8216.errorDescription'
		},
		8217: {
			errorName: 'Errors.8217.errorName',
			errorTitle: 'Errors.8217.errorTitle',
			errorDescription: 'Errors.8217.errorDescription'
		},
		8218: {
			errorName: 'Errors.8218.errorName',
			errorTitle: 'Errors.8218.errorTitle',
			errorDescription: 'Errors.8218.errorDescription'
		},
		8219: {
			errorName: 'Errors.8219.errorName',
			errorTitle: 'Errors.8219.errorTitle',
			errorDescription: 'Errors.8219.errorDescription'
		},
		8220: {
			errorName: 'Errors.8220.errorName',
			errorTitle: 'Errors.8220.errorTitle',
			errorDescription: 'Errors.8220.errorDescription'
		},
		8221: {
			errorName: 'Errors.8221.errorName',
			errorTitle: 'Errors.8221.errorTitle',
			errorDescription: 'Errors.8221.errorDescription'
		},
		8222: {
			errorName: 'Errors.8222.errorName',
			errorTitle: 'Errors.8222.errorTitle',
			errorDescription: 'Errors.8222.errorDescription'
		},
		8223: {
			errorName: 'Errors.8223.errorName',
			errorTitle: 'Errors.8223.errorTitle',
			errorDescription: 'Errors.8223.errorDescription'
		},
		16385: {
			errorName: 'Errors.16385.errorName',
			errorTitle: 'Errors.16385.errorTitle',
			errorDescription: 'Errors.16385.errorDescription'
		},
		16386: {
			errorName: 'Errors.16386.errorName',
			errorTitle: 'Errors.16386.errorTitle',
			errorDescription: 'Errors.16386.errorDescription'
		},
		16387: {
			errorName: 'Errors.16387.errorName',
			errorTitle: 'Errors.16387.errorTitle',
			errorDescription: 'Errors.16387.errorDescription'
		},
		16388: {
			errorName: 'Errors.16388.errorName',
			errorTitle: 'Errors.16388.errorTitle',
			errorDescription: 'Errors.16388.errorDescription'
		},
		16389: {
			errorName: 'Errors.16389.errorName',
			errorTitle: 'Errors.16389.errorTitle',
			errorDescription: 'Errors.16389.errorDescription'
		},
		16390: {
			errorName: 'Errors.16390.errorName',
			errorTitle: 'Errors.16390.errorTitle',
			errorDescription: 'Errors.16390.errorDescription'
		},
		16391: {
			errorName: 'Errors.16391.errorName',
			errorTitle: 'Errors.16391.errorTitle',
			errorDescription: 'Errors.16391.errorDescription'
		},
		16392: {
			errorName: 'Errors.16392.errorName',
			errorTitle: 'Errors.16392.errorTitle',
			errorDescription: 'Errors.16392.errorDescription'
		},
		16393: {
			errorName: 'Errors.16393.errorName',
			errorTitle: 'Errors.16393.errorTitle',
			errorDescription: 'Errors.16393.errorDescription'
		},
		16394: {
			errorName: 'Errors.16394.errorName',
			errorTitle: 'Errors.16394.errorTitle',
			errorDescription: 'Errors.16394.errorDescription'
		},
		16395: {
			errorName: 'Errors.16395.errorName',
			errorTitle: 'Errors.16395.errorTitle',
			errorDescription: 'Errors.16395.errorDescription'
		},
		16396: {
			errorName: 'Errors.16396.errorName',
			errorTitle: 'Errors.16396.errorTitle',
			errorDescription: 'Errors.16396.errorDescription'
		},
		16397: {
			errorName: 'Errors.16397.errorName',
			errorTitle: 'Errors.16397.errorTitle',
			errorDescription: 'Errors.16397.errorDescription'
		},
		16398: {
			errorName: 'Errors.16398.errorName',
			errorTitle: 'Errors.16398.errorTitle',
			errorDescription: 'Errors.16398.errorDescription'
		},
		16399: {
			errorName: 'Errors.16399.errorName',
			errorTitle: 'Errors.16399.errorTitle',
			errorDescription: 'Errors.16399.errorDescription'
		},
		16400: {
			errorName: 'Errors.16400.errorName',
			errorTitle: 'Errors.16400.errorTitle',
			errorDescription: 'Errors.16400.errorDescription'
		},
		16401: {
			errorName: 'Errors.16401.errorName',
			errorTitle: 'Errors.16401.errorTitle',
			errorDescription: 'Errors.16401.errorDescription'
		},
		16402: {
			errorName: 'Errors.16402.errorName',
			errorTitle: 'Errors.16402.errorTitle',
			errorDescription: 'Errors.16402.errorDescription'
		},
		16403: {
			errorName: 'Errors.16403.errorName',
			errorTitle: 'Errors.16403.errorTitle',
			errorDescription: 'Errors.16403.errorDescription'
		},
		16404: {
			errorName: 'Errors.16404.errorName',
			errorTitle: 'Errors.16404.errorTitle',
			errorDescription: 'Errors.16404.errorDescription'
		},
		16405: {
			errorName: 'Errors.16405.errorName',
			errorTitle: 'Errors.16405.errorTitle',
			errorDescription: 'Errors.16405.errorDescription'
		},
		65547: {
			errorName: 'Errors.65547.errorName',
			errorTitle: 'Errors.65547.errorTitle',
			errorDescription: 'Errors.65547.errorDescription'
		},
		65548: {
			errorName: 'Errors.65548.errorName',
			errorTitle: 'Errors.65548.errorTitle',
			errorDescription: 'Errors.65548.errorDescription'
		},
		65549: {
			errorName: 'Errors.65549.errorName',
			errorTitle: 'Errors.65549.errorTitle',
			errorDescription: 'Errors.65549.errorDescription'
		},
		65550: {
			errorName: 'Errors.65550.errorName',
			errorTitle: 'Errors.65550.errorTitle',
			errorDescription: 'Errors.65550.errorDescription'
		},
		65551: {
			errorName: 'Errors.65551.errorName',
			errorTitle: 'Errors.65551.errorTitle',
			errorDescription: 'Errors.65551.errorDescription'
		},
		65552: {
			errorName: 'Errors.65552.errorName',
			errorTitle: 'Errors.65552.errorTitle',
			errorDescription: 'Errors.65552.errorDescription'
		},
		65553: {
			errorName: 'Errors.65553.errorName',
			errorTitle: 'Errors.65553.errorTitle',
			errorDescription: 'Errors.65553.errorDescription'
		},
		65555: {
			errorName: 'Errors.65555.errorName',
			errorTitle: 'Errors.65555.errorTitle',
			errorDescription: 'Errors.65555.errorDescription'
		},
		65556: {
			errorName: 'Errors.65556.errorName',
			errorTitle: 'Errors.65556.errorTitle',
			errorDescription: 'Errors.65556.errorDescription'
		},
		65557: {
			errorName: 'Errors.65557.errorName',
			errorTitle: 'Errors.65557.errorTitle',
			errorDescription: 'Errors.65557.errorDescription'
		},
		65558: {
			errorName: 'Errors.65558.errorName',
			errorTitle: 'Errors.65558.errorTitle',
			errorDescription: 'Errors.65558.errorDescription'
		},
		65559: {
			errorName: 'Errors.65559.errorName',
			errorTitle: 'Errors.65559.errorTitle',
			errorDescription: 'Errors.65559.errorDescription'
		},
		65560: {
			errorName: 'Errors.65560.errorName',
			errorTitle: 'Errors.65560.errorTitle',
			errorDescription: 'Errors.65560.errorDescription'
		},
		65561: {
			errorName: 'Errors.65561.errorName',
			errorTitle: 'Errors.65561.errorTitle',
			errorDescription: 'Errors.65561.errorDescription'
		},
		65562: {
			errorName: 'Errors.65562.errorName',
			errorTitle: 'Errors.65562.errorTitle',
			errorDescription: 'Errors.65562.errorDescription'
		},
		65563: {
			errorName: 'Errors.65563.errorName',
			errorTitle: 'Errors.65563.errorTitle',
			errorDescription: 'Errors.65563.errorDescription'
		}
	}
};

export default translationKeys;
